import { render, staticRenderFns } from "./calques.vue?vue&type=template&id=2f369b59"
import script from "./calques.js?vue&type=script&lang=js&external"
export * from "./calques.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports